module.exports = __webpack_public_path__ + "img/P150T_weapon_102.1d71d0d5.png";